/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaUiCirclePlayIcon16Light = forwardRef('MediaUiCirclePlayIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.539 4.071A1 1 0 0 0 5 4.914v6.172a1 1 0 0 0 1.539.843l5.086-3.255a.8.8 0 0 0 0-1.348L6.539 4.071ZM6 4.914 10.822 8 6 11.086V4.914Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 1.004a7 7 0 1 0 0 14 7 7 0 0 0 0-14Zm-6 7a6 6 0 1 1 12 0 6 6 0 0 1-12 0Z" })));
});
